import React from 'react'
import { observer, inject } from 'mobx-react'

const CheckCircleIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='8' cy='8' r='7' />
    <path d='M5 8l2 2 4-4' />
  </svg>
)

const ErrorCircleIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='8' cy='8' r='7' />
    <line x1='5.5' y1='5.5' x2='10.5' y2='10.5' />
    <line x1='10.5' y1='5.5' x2='5.5' y2='10.5' />
  </svg>
)

const LoadingSpinnerIcon = () => (
  <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' style={{ animation: 'actionFeedbackToastSpin 0.8s linear infinite' }}>
    <path d='M21 12a9 9 0 1 1-6.219-8.56' />
  </svg>
)

const CloseIcon = () => (
  <svg width='14' height='14' viewBox='0 0 16 16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <line x1='4' y1='4' x2='12' y2='12' />
    <line x1='12' y1='4' x2='4' y2='12' />
  </svg>
)

const SuccessErrorModal = ({ uiStore }) => {
  const notification = uiStore && uiStore.notifications && uiStore.notifications[0]

  if (!notification || !notification.text) return null

  const { isError, isLoading, icon, text, category } = notification

  return (
    <div className='action-feedback-toast-container' style={{ zIndex: 10050 }}>
      <div className='action-feedback-toast'>
        <div
          className={`action-feedback-toast__icon-badge ${
            isError
              ? 'action-feedback-toast__icon-badge--error'
              : isLoading
                ? 'action-feedback-toast__icon-badge--loading'
                : 'action-feedback-toast__icon-badge--success'
          }`}
        >
          {isError && <ErrorCircleIcon />}
          {!isError && isLoading && <LoadingSpinnerIcon />}
          {!isError && !isLoading && !icon && <CheckCircleIcon />}
          {typeof icon === 'function' ? icon() : icon}
        </div>
        <span className='action-feedback-toast__text'>
          <span dangerouslySetInnerHTML={{ __html: text }} /> {category && category !== 'Success' && category !== 'Error' && <span className='modal-category'>{category}</span>}
        </span>
        {!isLoading && (
          <button
            type='button'
            className='action-feedback-toast__close-btn'
            onClick={() => uiStore.clearNotification(notification.id)}
            aria-label='Close notification'
          >
            <CloseIcon />
          </button>
        )}
      </div>
    </div>
  )
}

export default inject('uiStore')(observer(SuccessErrorModal))
